import { render, staticRenderFns } from "./ModalConfirm2.vue?vue&type=template&id=318354ca&scoped=true"
import script from "./ModalConfirm2.vue?vue&type=script&lang=js"
export * from "./ModalConfirm2.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirm2.vue?vue&type=style&index=0&id=318354ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318354ca",
  null
  
)

export default component.exports